import { Spinner } from '@chakra-ui/react';

export default function Loader(props: any) {
  return (
    <div style={{ position: 'fixed', left: '50%', top: '50%' }}>
      <Spinner size="xl"></Spinner>
    </div>
  );
}
